import React from 'react';
export default function TimePresets({ onChange }) {
  return <div className="d-flex gap-2 mb-3" role="group" aria-label="Tiempo rápido">{[15, 30, 60].map((minutes) => <button key={minutes} type="button" className="btn btn-sm btn-outline-primary" onClick={() => onChange(Math.floor(minutes / 60), minutes % 60)}>{minutes === 60 ? '1 h' : `${minutes} min`}</button>)}</div>;
}
